"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

/**
 * Polyfill for elementsFromPoint when browser has msElementsFromPoint function
 * Documentation: https://developer.mozilla.org/en-US/docs/Web/API/DocumentOrShadowRoot/elementsFromPoint
 * @param window
 */
function _default(window) {
  if (!window.document.elementsFromPoint && window.document.msElementsFromPoint) {
    window.document.elementsFromPoint = window.document.msElementsFromPoint;
  }
}
//# sourceMappingURL=elementsFromPointPolyfill.js.map